// Matches the public surface of newRelicClient.platform.ts. All no-ops on
// web since Bookwise doesn't ship on web; this file exists only so Metro
// can resolve `import ... from './newRelicClient'` in shared code.

import type { NrEventPayloads } from './nrEventPayloads';
import type { NrEvent } from './nrEvents';

const noop = () => undefined;

export function event<K extends NrEvent>(_kind: K, _attrs: NrEventPayloads[K]): void {
  // no-op on web
}

export function flattenAttributes(_value: unknown, _prefix = ''): { [key: string]: string | number | boolean | null } {
  // no-op on web — telemetry emitter is stubbed out anyway
  return {};
}
export const log = {
  info: noop,
  warn: noop,
  error: noop,
  debug: noop,
  verbose: noop,
};
export const setSessionIdAttribute = noop;
export const setUserContext = noop;
